import { render, staticRenderFns } from "./ColorInput.vue?vue&type=template&id=b066a3ba&scoped=true&"
import script from "./ColorInput.vue?vue&type=script&lang=js&"
export * from "./ColorInput.vue?vue&type=script&lang=js&"
import style0 from "./ColorInput.vue?vue&type=style&index=0&id=b066a3ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b066a3ba",
  null
  
)

export default component.exports